import script from "./batch-update.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-update.vue?vue&type=script&lang=ts&setup=true"

import "./batch-update.vue?vue&type=style&index=0&id=780da758&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780da758"]])

export default __exports__